import { Fragment } from 'react'
import { ObjectTypes, useObjectGet } from '../api/object'
import { DetailLayout } from '../layouts/types'
import { getFormatter } from './formatters'

export function ObjectTooltip({
	config,
	object,
	id,
}: {
	config: DetailLayout
	object: keyof ObjectTypes
	id: string
}) {
	const { data } = useObjectGet(object, id)

	return (
		<div className="grid grid-cols-[auto_auto] gap-x-4 gap-y-1">
			{config.columns.map(column => {
				const renderer = getFormatter(column)
				return (
					<Fragment key={column.key}>
						<div>{column.label}:</div>
						<div>{renderer(data?.[column.key], column, data, object)}</div>
					</Fragment>
				)
			})}
		</div>
	)
}
